export const canSaveMap = () => () => {
    return function () {
        const {bizNodeType} = this.root.data
        return 'function' === typeof this.BizNode[bizNodeType].updateMap
    }
}

export const saveMap = () => {
    return () => async function () {
        const {bizNodeType} = this.root.data
        await this.BizNode[bizNodeType].updateMap(this, this.root)
    }
}
